import { render, staticRenderFns } from "./StaticSectionEmail.vue?vue&type=template&id=046b7bf2"
import script from "./StaticSectionEmail.vue?vue&type=script&lang=js"
export * from "./StaticSectionEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports